

















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Wave } from '@/interfaces/Wave';
import { Cutoverplan } from '@/interfaces/Cutoverplan';

type Breadcrumb = {
  link: string;
  text: string;
};

function leaveOnlyNumbers(path: string): boolean {
  return !!(path && !Number.isNaN(+path));
}

function convertToNumber(value: string | number): number {
  return +value;
}

@Component({})
export default class AppBreadcrumbs extends Vue {
  @Watch('$route')
  routeChanged() {
    this.refreshBreadcrumb();
  }

  @Watch('$store.state.module_ids_to_name_map')
  watchIdsMap() {
    this.refreshBreadcrumb();
  }

  get all_cutoverplans() {
    return this.$store.state.all_cutoverplans;
  }

  get module_ids_to_name_map() {
    return this.$store.state.module_ids_to_name_map;
  }

  private breadcrumbs: Breadcrumb[] = [];

  created() {
    Promise.all([
      this.$store.dispatch('refreshData'),
      this.$store.dispatch('refreshIdstoNameMap')
    ]).then(() => {
      this.refreshBreadcrumb();
    });
  }

  refreshBreadcrumb() {
    const routeParts: string[] = this.$route.path.split('/');
    const numbersInPath: number[] = routeParts.filter(leaveOnlyNumbers).map(convertToNumber);

    const matchedRoutes = this.$route.matched;

    const breadcrumbs: Breadcrumb[] = [];

    let cutoverplanId: number | undefined;
    let moduleId: number | undefined;
    let waveId: number | undefined;

    let breadCrumbText: string | undefined = '';

    matchedRoutes.forEach((match) => {
      const breadcrumbInMeta = match.meta?.breadCrumb;

      switch (breadcrumbInMeta) {
        case '[cutoverplan]':
          cutoverplanId = numbersInPath.shift();
          breadCrumbText = this.all_cutoverplans.find(
            (cutoverplan: Cutoverplan) => cutoverplan.id === cutoverplanId
          )?.name;
          break;
        case '[module]': {
          moduleId = numbersInPath.shift() as number;
          const moduleLanguage =
            this.module_ids_to_name_map[moduleId].find(
              (mL: any) => mL.languageId === this.$store.state.user.languageId
            ) || this.module_ids_to_name_map[moduleId][0];
          breadCrumbText = moduleLanguage.name;
          break;
        }
        case '[username]':
          breadCrumbText = this.$store.state.user.name;
          break;
        case '[wave]':
          waveId = numbersInPath.shift();
          breadCrumbText = this.$store.state.all_waves.find((wave: Wave) => wave.id === waveId)
            ?.name;
          break;
        default:
          break;
      }

      if (breadcrumbInMeta) {
        let link = `${this.replaceTemplatesWithNumbers(
          match.path,
          cutoverplanId,
          moduleId,
          waveId
        )}`;
        const linkEndsWithDigit = link.match(/[0-9]$/);
        if (linkEndsWithDigit || link === '') link += '/';

        let selectedEnvironmentId: number | undefined;

        const urlParams = window.location.search?.split('=');
        if (urlParams.length > 1) selectedEnvironmentId = +urlParams[1];

        if (selectedEnvironmentId && (link.match(/[0-9]\/$/) || link.endsWith('module')))
          link += `?env=${selectedEnvironmentId}`;

        breadcrumbs.push({
          link,
          text: breadCrumbText || breadcrumbInMeta
        });
      }
      breadCrumbText = '';
    });

    this.breadcrumbs = breadcrumbs;
  }

  replaceTemplatesWithNumbers(
    link: string,
    cutoverplanId?: number,
    moduleId?: number,
    waveId?: number
  ): string {
    return link
      .replace(':cutoverplan_id', `${cutoverplanId}`)
      .replace(':module_id', `${moduleId}`)
      .replace(':wave_id', `${waveId}`);
  }
}
